<script>
	import { SquareDashed } from 'lucide-svelte';

	export let iconClass = '';
</script>

<SquareDashed class={iconClass} />